import { Fragment, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { Button } from '@material-tailwind/react'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { P } from '../../../components/typography/typography'
import practiceService from '../../../Services/practice.services'

const DeletePracticeDialog = (props: any) => {
  const [errorMessage, setErrorMessage] = useState('')
  const [isDeleting, setIsDeleting] = useState(false)

  function closeModal() {
    props.stateManager()
    setErrorMessage('')
  }

  const deletePractice = async () => {
    setErrorMessage('')
    setIsDeleting(true)
    try {
      await practiceService.DeletePractice(props.data.id)
      toast.success('Practice deleted successfully', { position: 'top-center' })
      props.GetPractices()
      closeModal()
    } catch (error: any) {
      // A 409 explains that dentists are still linked to the practice
      setErrorMessage(error?.response?.data?.error ?? 'Something went wrong')
    } finally {
      setIsDeleting(false)
    }
  }

  return (
    <div>
      <Transition appear show={props.isOpen} as={Fragment}>
        <Dialog as="div" className="fixed inset-0 z-50 overflow-y-auto" onClose={closeModal}>
          <div className="min-h-screen px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" />
            </Transition.Child>

            <span className="inline-block h-screen align-middle" aria-hidden="true">
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="inline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                <Dialog.Title as="h1" className="font-medium leading-tight text-2xl mt-0 mb-2 text-black-600">
                  Do you want to delete {props.data?.name}?
                </Dialog.Title>
                {errorMessage && <P className="text-red-600">{errorMessage}</P>}

                <div className="mt-4 flex justify-end">
                  <Button type="button" onClick={closeModal} className="mr-2">
                    Cancel
                  </Button>
                  <Button type="button" color="red" disabled={isDeleting} onClick={deletePractice}>
                    Delete
                  </Button>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </div>
  )
}

export default DeletePracticeDialog
